<template>
  <ui-check-selectbox
    id="signUpTimezone"
    :width="width"
    :height="height"
    :full="full"
    :maxHeight="321"
    :search="true"
    :value="value"
    :items="items"
    :disabled="disabled"
    :readonly="readonly"
    :modelError="modelError"
    :placeholder="placeholder"
    @input="onCountryCodeChange"/>
</template>

<script>
import countryCode from '@/data/country-code'
import UiCheckSelectbox from './UiCheckSelectbox'

export default {
  name: 'CountryCodeSelectbox',
  components: {
    UiCheckSelectbox
  },
  props: [
    'value',
    'full',
    'height',
    'width',
    'disabled',
    'readonly',
    'modelError',
    'placeholder'
  ],
  computed: {
    items () {
      let list = Object.entries(countryCode).map(([key, value]) => {
        return {
          value: key,
          text: value.continent,
          items: Object.entries(value.country).map(([k, v]) => {
            return {
              value: k,
              text: v
            }
          })
        }
      })

      list.sort((a, b) => {
        if (a.value === 'All') {
          return -1
        } else if (b.value === 'All') {
          return 1
        } else {
          return a.text[this.$i18n.locale].localeCompare(b.text[this.$i18n.locale])
        }
      })

      return list
    }
  },
  methods: {
    onCountryCodeChange (value) {
      this.$emit('change', value)
    }
  }
}
</script>

<style>

</style>
